"use strict";

var _taggedTemplateLiteral = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionTag = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var css_1 = require("@emotion/css");

var useMediaContext_1 = require("../context/useMediaContext");

var NFTDataContext_1 = require("../context/NFTDataContext");

var Orb_1 = require("../components/Orb");

var CollectionTag = function CollectionTag() {
  var _react_1$useContext = react_1.useContext(NFTDataContext_1.NFTDataContext),
      data = _react_1$useContext.nft.data;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles;

  var getContent = function getContent() {
    return jsx_runtime_1.jsxs("a", Object.assign({}, getStyles("colectionTagWrapper"), {
      href: "https://zora.co/collections/".concat(data === null || data === void 0 ? void 0 : data.nft.contract.address),
      target: "_blank",
      rel: "noreferrer"
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({}, getStyles("collectionTagIcon"), {
        children:
        /* @ts-ignore */
        data && "openseaInfo" in data ? jsx_runtime_1.jsx("img", {
          src: data.openseaInfo.asset_contract.image_url,
          alt: data.openseaInfo.asset_contract.name
        }, void 0) : jsx_runtime_1.jsx(Orb_1.Orb, {}, void 0)
      }), void 0), jsx_runtime_1.jsx("span", {
        children: data && "openseaInfo" in data ? "".concat(data.openseaInfo.asset_contract.name) : 'Zora'
      }, void 0)]
    }), void 0);
  };

  return jsx_runtime_1.jsx("div", Object.assign({
    className: css_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      position: relative;\n      display: flex;\n      flex-direction: row;\n    "])))
  }, {
    children: data ? getContent() : '...'
  }), void 0);
};

exports.CollectionTag = CollectionTag;